var o = () => {
  try {
    const e = globalThis;
    if (typeof e.__BQUERY_DEV__ == "boolean") return e.__BQUERY_DEV__;
    const r = e.process?.env?.NODE_ENV;
    if (typeof r == "string") return r !== "production";
    const n = e.process?.versions?.node;
    if (typeof n == "string" && n.length > 0) return !0;
    const t = e.process?.release?.name;
    return t === "node" || t === "io.js";
  } catch {
    return !1;
  }
};
export {
  o as t
};

//# sourceMappingURL=env-PvwYHnJq.js.map